"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderScreen = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var _1 = require(".");
var Theme_1 = require("../../Theme");
var Wrapper = styled_components_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    margin: 0;\n    padding: 0;\n    z-index: 1;\n    background-color: white;\n    color: ", ";\n    font-family: ", ";\n"], ["\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n    margin: 0;\n    padding: 0;\n    z-index: 1;\n    background-color: white;\n    color: ", ";\n    font-family: ", ";\n"])), Theme_1.Color.Grey.G80, Theme_1.FontFamily);
var Content = styled_components_1.default.section(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    overflow: auto;\n    height: 100%;\n"], ["\n    overflow: auto;\n    height: 100%;\n"])));
var HeaderScreen = /** @class */ (function (_super) {
    __extends(HeaderScreen, _super);
    function HeaderScreen() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleKeyDownClose = function (e) {
            var keyCode = e.keyCode;
            if (keyCode === 27) {
                _this.props.OnCloseRequest();
            }
        };
        return _this;
    }
    HeaderScreen.prototype.render = function () {
        return (React.createElement(Wrapper, { onKeyDown: this.handleKeyDownClose },
            React.createElement(_1.HeaderScreenHeader, { Caption: this.props.Caption, OnCloseRequest: this.props.OnCloseRequest }),
            React.createElement(Content, null,
                React.createElement(_1.HeaderScreenContent, null, this.props.children)),
            React.createElement(_1.HeaderScreenFooter, { PrimaryButtonCaption: this.props.PrimaryButtonCaption, TertiaryButtonCaption: this.props.TertiaryButtonCaption, OnPrimaryButtonClick: this.props.OnPrimaryButtonClick, OnTertiaryButtonClick: this.props.OnCloseRequest })));
    };
    return HeaderScreen;
}(React.Component));
exports.HeaderScreen = HeaderScreen;
var templateObject_1, templateObject_2;
